<template>
  <div class="ui grid">
  <div class="two wide column"></div>
 <!-- <div class="three wide column"><TheGraph graphname="inventory" query="aachen"></TheGraph></div>-->
  <div class="three wide column"></div>
  <div class="three wide column"></div>
  <div class="three wide column"></div>
  <div class="two wide column"></div>
</div>
  
</template>

<script>
  import TheGraph from '../components/TheGraph.vue'
  export default {
    name: 'dashboard',
    components: {
      TheGraph
    },
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/router/dashboard.vue